import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { conversationService, type CreateConversationInput } from '@/services/conversationService';

export function useConversationList(opts?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: ['conversations', opts],
    queryFn: () => conversationService.list(opts),
  });
}

export function useConversation(id: string | null) {
  return useQuery({
    queryKey: ['conversation', id],
    queryFn: () => conversationService.get(id!),
    enabled: !!id,
  });
}

export function useCreateConversation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateConversationInput) => conversationService.create(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['conversations'] });
    },
  });
}

export function useSendMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, message }: { id: string; message: string }) =>
      conversationService.sendMessage(id, message),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['conversation', vars.id] });
    },
  });
}

export function useDeleteConversation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => conversationService.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['conversations'] });
    },
  });
}
